export const BFF_PROXY_PREFIX = "/bff";

export function bffUrl(path: string): string {
  return `${BFF_PROXY_PREFIX}/${path.replace(/^\/+/, "")}`;
}
